<template>
  <el-dialog :visible.sync="visible" :title="'争章集赞家长通知'" :close-on-click-modal="false"
             :close-on-press-escape="false" :append-to-body="true">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
             :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
      <el-form-item label="标题" prop="title">
        <el-input v-model="dataForm.title" placeholder="标题"></el-input>
      </el-form-item>
      <el-form-item label="学校" prop="schoolId" v-if="schoolVisible">
        <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable @change="schoolChangeHandle()">
          <el-option v-for="school in schoolList" :label="school.schoolName" :value="school.id"
                     :key="school.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="微信通知" prop="isWeChat">
        <el-switch
            v-model="dataForm.isWeChat"
            @change="isUseHandle(templateType.WE_CHAT)"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="isUse.YES"
            :inactive-value="isUse.NO">
        </el-switch>
      </el-form-item>
      <el-form-item v-if="dataForm.isWeChat" label="微信模版" prop="weChatTemplateId">
        <el-select v-model="dataForm.weChatTemplateId" clearable placeholder="微信模版">
          <el-option
              v-for="item in weChatTemplates"
              :key="item.id"
              :label="item.templateTitle"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button @click="configTemplateParams(templateType.WE_CHAT)" style="margin-left: 20px" type="primary">发送内容
        </el-button>
      </el-form-item>

    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
    <message-config-params v-if="messageConfigParamsVisible" ref="messageConfigParams"
                           @setParams="setParams"></message-config-params>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { isUse, templateType } from '@/constant'
import MessageConfigParams from '@/views/modules/message/message-config-params'

export default {
  name: 'studentEvaluate-parents-message',
  components: { MessageConfigParams },
  data () {
    return {
      visible: false,
      messageConfigParamsVisible: false,
      isUse,
      templateType,
      weChatTemplates: [],
      shortMessageTemplates: [],
      schoolList: [],
      schoolVisible: false,
      dataForm: {
        title: '',
        schoolId: '',
        isWeChat: isUse.NO,
        weChatTemplateId: '',
        isShortMessage: isUse.NO,
        shortMessageTemplateId: '',
        weChatMessageNoticeGroupParams: {},
        shortMessageNoticeGroupParams: {}
      }
    }
  },
  computed: {
    dataRule () {
      return {
        title: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isWeChat: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        weChatTemplateId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isShortMessage: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        shortMessageTemplateId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        schoolId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.resetValue()
        this.getInitInfo()
      })
    },
    /**
     * 初始化信息
     * */
    getInitInfo () {
      this.getInfo().then(() => {
        this.getSortMessageTemplateList().then(() => {
          this.getWeChatTemplateList().catch((err) => {
            return this.$message.error(err.message)
          })
        }).catch((err) => {
          return this.$message.error(err.message)
        })
      }).catch((err) => {
        return this.$message.error(err.message)
      })
    },
    /**
     *  获取微信模板集合
     * @returns {Promise<AxiosResponse<any>>}
     */
    getWeChatTemplateList () {
      return this.$http.get(`/message/template/getTemplateByType?type=${this.templateType.WE_CHAT}&schoolId=${this.dataForm.schoolId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          if (res.code === 10050) {
            this.schoolVisible = true
            this.getSchoolList()
            throw new Error(res.msg)
          }
          return this.$message.error(res.msg)
        }
        this.weChatTemplates = res.data
      })
    },
    /**
     * 获取短信模板集合
     * @returns {Promise<AxiosResponse<any>>}
     */
    getSortMessageTemplateList () {
      return this.$http.get(`/message/template/getTemplateByType?type=${this.templateType.SHORT_MESSAGE}&schoolId=${this.dataForm.schoolId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          if (res.code === 10050) {
            this.schoolVisible = true
            this.getSchoolList()
            throw new Error(res.msg)
          }
          return this.$message.error(res.msg)
        }
        this.shortMessageTemplates = res.data
      })
    },
    /**
     * 获取学校的集合
     */
    getSchoolList () {
      this.$http.get('/school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    /**
     * 学校改变事件
     * */
    schoolChangeHandle () {
      this.getInitInfo()
    },
    configTemplateParams (type) {
      let messageParamsConfig = {}
      if (type === this.templateType.SHORT_MESSAGE) {
        if (!this.dataForm.shortMessageTemplateId) {
          return this.$message.error('请选择模版')
        }
        const template = this.shortMessageTemplates.filter((item) => this.dataForm.shortMessageTemplateId === item.id)[0]
        messageParamsConfig = {
          content: this.dataForm.shortMessageNoticeGroupParams,
          keyExplains: template.keyExplain,
          templateType: templateType.SHORT_MESSAGE
        }
      }
      if (type === this.templateType.WE_CHAT) {
        if (!this.dataForm.weChatTemplateId) {
          return this.$message.error('请选择模版')
        }
        const template = this.weChatTemplates.filter((item) => this.dataForm.weChatTemplateId === item.id)[0]
        messageParamsConfig = {
          content: this.dataForm.weChatMessageNoticeGroupParams,
          keyExplains: template.keyExplain,
          templateType: templateType.WE_CHAT
        }
      }
      this.messageConfigParamsVisible = true
      this.$nextTick(() => {
        let keyExplain = []
        if (messageParamsConfig.keyExplains && messageParamsConfig.keyExplains !== '[]') {
          keyExplain = JSON.parse(messageParamsConfig.keyExplains)
        }
        // 存在 键，但是但是内容为空则位第一次
        if (!messageParamsConfig.content && keyExplain.length > 0) {
          messageParamsConfig.content = {}
          keyExplain.map((item) => {
            messageParamsConfig.content[item.key] = ''
          })
        }
        // 不存在键 则所有都为空
        if (keyExplain.length === 0) {
          // messageParamsConfig.content = {}
          if (type === this.templateType.WE_CHAT) {
            this.dataForm.weChatMessageNoticeGroupParams = {}
          }
          if (type === this.templateType.SHORT_MESSAGE) {
            this.dataForm.shortMessageNoticeGroupParams = {}
          }
          return this.$message.error('该模板暂无可设置内容，直接选择即可')
        }
        // 不是第一次
        if (messageParamsConfig.content && messageParamsConfig.content !== '{}' && keyExplain.length > 0) {
          if (typeof messageParamsConfig.content === 'string') {
            messageParamsConfig.content = JSON.parse(messageParamsConfig.content)
          }
        }
        this.$refs.messageConfigParams.init()
        this.$refs.messageConfigParams.keyExplains = keyExplain
        this.$refs.messageConfigParams.dataForm = messageParamsConfig.content
        this.$refs.messageConfigParams.templateType = messageParamsConfig.templateType
      })
    },
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        if (!this.dataForm.shortMessageTemplateId && !this.dataForm.weChatTemplateId) {
          return this.$message.error('至少选择一种通知')
        }
        // 短信判断
        if (this.dataForm.shortMessageTemplateId) {
          const template = this.shortMessageTemplates.filter((item) => this.dataForm.shortMessageTemplateId === item.id)[0]
          let keyExplain = []
          if (template.keyExplain && template.keyExplain !== '[]') {
            keyExplain = JSON.parse(template.keyExplain)
          }
          // 如果键不为空
          if (keyExplain.length > 0) {
            // 值不填
            if (!this.dataForm.shortMessageNoticeGroupParams || this.dataForm.shortMessageNoticeGroupParams === '{}') {
              return this.$message.error('请填写短信内容')
            }
          }
        }
        // 微信判断
        if (this.dataForm.weChatTemplateId) {
          const template = this.weChatTemplates.filter((item) => this.dataForm.weChatTemplateId === item.id)[0]
          let keyExplain = []
          if (template.keyExplain && template.keyExplain !== '[]') {
            keyExplain = JSON.parse(template.keyExplain)
          }
          // 如果键不为空
          if (keyExplain.length > 0) {
            // 值不填
            if (!this.dataForm.weChatMessageNoticeGroupParams || this.dataForm.weChatMessageNoticeGroupParams === '{}') {
              return this.$message.error('请填写微信内容')
            }
          }
        }
        this.$http.post(`/thumb/studentThumbParentsMessage?schoolId=${this.dataForm.schoolId}`, this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
            }
          })
        })
      })
    }, 1000, { leading: true, trailing: false }),
    /**
     * 重置参数
     */
    resetValue () {
      this.dataForm.schoolId = ''
      this.dataForm.isShortMessage = isUse.NO
      this.dataForm.isWeChat = isUse.NO
      this.schoolVisible = false
    },
    /**
     *
     * 获得信息
     */
    getInfo () {
      return this.$http.get(`/thumb/studentThumbParentsMessage/getValue?schoolId=${this.dataForm.schoolId}`).then(({ data: res }) => {
        if (res.code === 10050) {
          this.schoolVisible = true
          this.getSchoolList()
          throw new Error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.dataForm.isWeChat = res.data.isWeChat || isUse.NO
        this.dataForm.isShortMessage = res.data.isShortMessage || isUse.NO
      })
    },

    /**
     * 模板的参数回调设置
     * @param data
     */
    setParams (data, type) {
      if (type === this.templateType.WE_CHAT) {
        this.dataForm.weChatMessageNoticeGroupParams = data
      }
      if (type === this.templateType.SHORT_MESSAGE) {
        this.dataForm.shortMessageNoticeGroupParams = data
      }
    },
    isUseHandle (type) {
      if (type === this.templateType.SHORT_MESSAGE) {
        if (this.dataForm.isShortMessage === this.isUse.NO) {
          this.dataForm.shortMessageTemplateId = ''
          this.dataForm.shortMessageNoticeGroupParams = {}
        }
      }
      if (type === this.templateType.WE_CHAT) {
        if (this.dataForm.isWeChat === this.isUse.NO) {
          this.dataForm.weChatTemplateId = ''
          this.dataForm.weChatMessageNoticeGroupParams = {}
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
